export default __webpack_public_path__ + "static/ActaAgate-Bold-1d3fff0a18f43b5a31e6b74d14687aa8.woff";